import { client } from "api";
import { Creator } from "models/Checklist";
import { GetAllUsersRequest } from "./getAllUsers";

export type GetAllUsersLimitedResponse = Creator[];

export const getAllUsersLimited = (
  request: GetAllUsersRequest
): Promise<GetAllUsersLimitedResponse> =>
  client
    .get<GetAllUsersLimitedResponse>(`/user/listmin`, {
      params: {
        roles: request?.roles?.join(","),
        departmentIds: request?.departmentIds?.join(","),
        officeIds: request?.officeIds?.join(","),
        inactive: request?.inactive,
      },
    })
    .then((res) => res.data);
